<template>
  <Dropdown trigger="click" class="dropDown" @on-click="itemClick">
    <div class="menuIcon"></div>
    <DropdownMenu slot="list">
      <DropdownItem v-for="item in navData" :name="item.link" :key="item.key">{{item.name}}</DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
import navSource from '../json/navbar'
export default {
  name: "drop-down",
  data() {
    return {
      navData: navSource.navData
    }
  },
  methods: {
    itemClick(item) {
      this.$router.push(item)
    }
  },
}
</script>
<style scoped lang="less">
.dropDown {
  position: absolute;
  top: 0;
  right: 0;
  .menuIcon {
    width: 44px;
    height: 44px;
    background: url("../assets/menu.png") no-repeat;
    background-size: 32px 32px;
    background-position: center center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropDown.vue